"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[4143],{

/***/ 4143:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ videoPlayer)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
// components/video-player.js [aa 1/24]


/**
 * Handles play and pause button controls for all videos inside of a given wrapper
 * @param { HTMLElement } wrapper VideoWrapper
 *  @example
 *  <div data-component="video-player">
 *    <video></video>
 *    <button data-hook="play-pause"></button>
 *  </div>
 */

function videoPlayer({ wrapper }) {
  const { classes } = window.config

  let $wrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper)

  let settings = {
    video: 'video',
    playPauseBtn: '[data-hook="play-pause"]',
  }

  const cache = {
    $video: $wrapper.find(settings.video),
    $playPauseBtn: $wrapper.find(settings.playPauseBtn),
  }

  let observer

  const initEventListeners = function () {
    cache.$playPauseBtn.on('click', playPauseVideo)

    const hasAutoplay = cache.$video.attr('autoplay')

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('autoplay') && !hasAutoplay) {
      // wrap this playVideo in a intersection observer instead of on page load.

      // it won't start autoplaying the video unless it's in view or close to being in view
      // playVideo()
      initObserver()
    }

    if (cache.$video.length) {
      cache.$video.each(function (index, video) {
        video.addEventListener('ended', handleVideoEnd, false)
      })
    }
  }

  const handleVideoEnd = function () {
    $wrapper.removeClass(classes.active)
  }

  const playPauseVideo = function (e) {
    e.stopImmediatePropagation()
    cache.$video.each(function (index, video) {
      if (!video || !jquery__WEBPACK_IMPORTED_MODULE_0___default()(video).is(':visible')) return

      if (video.paused) {
        video.play()
        $wrapper.addClass(classes.active)
      } else {
        video.pause()
        $wrapper.removeClass(classes.active)
      }
    })
  }

  const initObserver = function () {
    if (typeof IntersectionObserver === 'function') {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.25,
      }

      observer = new IntersectionObserver((e) => observeVideos(e), options)

      cache.$video.each(function (index, video) {
        observer.observe(video)
      })
    } else {
      playVideo()
    }
  }

  const observeVideos = function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // "autoplay" video
        playVideo()
        // need to disconnect observer
        observer.disconnect()
      }
    })
  }

  const playVideo = function () {
    cache.$video.each(function (index, video) {
      if (!video || !jquery__WEBPACK_IMPORTED_MODULE_0___default()(video).is(':visible')) return

      if (video.paused) {
        video.play()
        $wrapper.addClass('on')
      }
    })
  }

  initEventListeners()
}


/***/ })

}]);